import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-gray-50 font-sans" data-id="element-88">
      <Navigation data-id="element-89" />
      <main className="flex-grow" data-id="element-90">{children}</main>
      <Footer data-id="element-91" />
    </div>;
}